import { qs, qsa } from '../../resources/js/utils/dom'

// Create an Intl.NumberFormat formatter with desired options
const numberFormatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

// Util function
function addFormatter (input, formatFn) {
  let oldValue = input.value;
  
  const handleInput = (event) => {
		let newValue = input.classList.contains('currency') ? '$' + numberFormatter.format(input.value.replace(/\D/g,'')) : input.value;
    const result = formatFn(newValue, oldValue, event);
    if (typeof result === 'string') {
      input.value = result;
    }
    
    oldValue = input.value;
  }

  handleInput();
  input.addEventListener("input", handleInput);
}

// Example implementation
// HOF returning regex prefix formatter
function regexPrefix (regex, prefix) {
  return (newValue, oldValue) => regex.test(newValue) ? newValue : (newValue ? oldValue : prefix);
}

function externalCalc (item) {
	return Math.ceil(Number(item.value.replace(/\D/g,'')) * (1 - Number(qs('#save_percent').value.replace(/\D/g,'')) / 100));
}

function spendCalc (item1, item2) {
	return (Number(item1.value.replace(/\D/g,'')) * Number(item2.value.replace(/\D/g,''))).toFixed(0);
}

function saveCalc (item1, item2, item3) {
	return ((Number(item1.value.replace(/\D/g,'')) * Number(item2.value.replace(/\D/g,''))) - (Number(item1.value.replace(/\D/g,'')) * Number(item3.innerText))).toFixed(0);
}

function saveMarketCalc (item) {
	return (Number(item.innerText.replace(/\D/g,'')) * 0.9).toFixed(0);
}

function sectionTotal (selector, container) {
	let sum = 0;

	qsa(selector, container).forEach((item) => {
		sum += Number(item.innerText.replace(/\D/g,''));
	});

	return sum;
}

function tableTotal () {
	let tableSum = 0;

	qsa('.total-save').forEach((item) => {
		tableSum += Number(item.innerText.replace(/\D/g,''));
	});

	tableSum -= Number(qs('#budget').value.replace(/\D/g,''));

	return tableSum;
}

function percentTotal () {
	let totalSpend = 0;

	qsa('.total-spend').forEach((item) => {
		totalSpend += Number(item.innerText.replace(/\D/g,''));
	});

	return ((Number(qs('.total-table').innerText.replace(/\D/g,'')) / totalSpend).toFixed(2) * 100).toFixed(0);
}

function updateTable (inputParent) {
	const inputTable = inputParent.closest('table');
	if (qs('.external', inputParent)) {
		qs('.external', inputParent).innerHTML = parseFloat(externalCalc(qs('.number', inputParent)));
	}

	if (qs('.spend', inputParent)) {
		qs('.spend', inputParent).innerHTML = '$' + numberFormatter.format(parseFloat(spendCalc(qs('.price', inputParent), qs('.number', inputParent))));
	}

	if (qs('.save', inputParent)) {
		qs('.save', inputParent).innerHTML = '$' + numberFormatter.format(parseFloat(saveCalc(qs('.price', inputParent), qs('.number', inputParent), qs('.external', inputParent))));
	} 

	if (qs('.save-market', inputParent)) {
		qs('.save-market', inputParent).innerHTML = '$' + numberFormatter.format(parseFloat(saveMarketCalc(qs('.spend', inputParent))));
	}

	if (qs('.total-spend', inputTable)) {
		qs('.total-spend', inputTable).innerHTML = '$' + numberFormatter.format(parseFloat(sectionTotal('.spend', inputTable)));
	}

	if (qs('.total-save', inputTable)) {
		qs('.total-save', inputTable).innerHTML = '$' + numberFormatter.format(parseFloat(sectionTotal('.save', inputTable)));
	}

	if (qs('.total-market', inputTable)) {
		qs('.total-market', inputTable).innerHTML = '$' + numberFormatter.format(parseFloat(sectionTotal('.save-market', inputTable)));
	}

	if (qs('.total-table')) {
		qs('.total-table').innerHTML = '$' + numberFormatter.format(parseFloat(tableTotal()));
	}

	if (qs('.save-percent-total')) {
		qs('.save-percent-total').innerHTML = !isNaN(percentTotal()) && parseFloat(percentTotal()) > 0 && parseFloat(percentTotal()) < 100 ? parseFloat(percentTotal()) + '%' : '0%';
	}
}

// Apply formatter for $
qsa('.currency').forEach((input) => {
  addFormatter(input, regexPrefix(/^\$/, '$'));
});

// Apply formatter for %
qsa('.percent').forEach((input) => {
  addFormatter(input, regexPrefix(/%$/, '%'));
});

window.addEventListener('input', (event) => {
	if (event.target.matches('.roi-calculator-table input')) {
		if (event.target.matches('#save_percent')) {
			qsa('.update-table tr').forEach((item) => {
				updateTable(item);
			});
			qsa('.save-percent').forEach((item) => {
				item.innerText = qs('#save_percent').value;
			});
		} else {
			updateTable(event.target.closest('tr'));
		}
	}
});
